import { batch } from 'react-redux';
import { initialize } from 'redux-form';
import { CommanderThunkAction, WithBillId, WithScope } from '@mews-commander/types';
import { openDialog } from '../../../../../modules/dialog/reducer';

export const DELETE_BILL_ACTION_DIALOG = 'deleteBillActionDialog';

interface DeleteBillActionDialogData extends WithScope, WithBillId {
    onClose?: () => void;
}

export const openDeleteBillActionDialog =
    ({ billId, scope, onClose }: DeleteBillActionDialogData): CommanderThunkAction =>
    (dispatch) => {
        batch(() => {
            dispatch(initialize(DELETE_BILL_ACTION_DIALOG, { billId, scope, onClose }));
            dispatch(openDialog(DELETE_BILL_ACTION_DIALOG));
        });
    };
